// eslint-disable-import/no-named-as-default
import { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch, Redirect, useParams } from 'react-router-dom';
import { USER_ROLES } from '@pwc/pwc-deals-web-common';
import { Loader } from '@pwc/pwc-deals-ui';
import { getUserRole } from 'common/redux/security/loggedInUser/loggedInUserSlice';
import userTokenService from 'common/services/security/userTokenService';
import authorizationService from 'common/services/security/authorizationService';
import featureFlags from 'common/helpers/featureFlags';
import ProjectImport from './ProjectImport';
import { getProjectTerritory } from '../project/projectSlice';

const ProjectImportPageRouter: FunctionComponent = () => {
  const { projectId }: { projectId: string } = useParams();
  const isPwcUser = useSelector(getUserRole) === USER_ROLES.PWC_USER;
  const hasValidToken = authorizationService.hasValidToken();
  const isReadOnly = userTokenService.isPwcReadOnlyRole(projectId);
  const territory = useSelector(getProjectTerritory);

  const loadProjectImportMFE =
    territory &&
    featureFlags.isProjectImportEnabled &&
    hasValidToken &&
    !isReadOnly &&
    isPwcUser;
  return (
    <>
      <Switch>
        <Route exact path="/projects/:projectId/content-set">
          {!territory && <Loader />}
          {territory &&
            (loadProjectImportMFE ? (
              <ProjectImport />
            ) : (
              <Redirect to="/unauthorized" />
            ))}
        </Route>

        <Route exact path="/projects/:projectId/content-set">
          {!territory && <Loader />}
          {territory &&
            (loadProjectImportMFE ? (
              <ProjectImport />
            ) : (
              <Redirect to="/unauthorized" />
            ))}
        </Route>
      </Switch>
    </>
  );
};

export default ProjectImportPageRouter;
